import { permissionAreaKeyNameOf } from "../../../helpers/permission.helpers";
import { BillingArea } from "../../../models/roles";
import { MenuMainNode } from "./nodes";

export function entityKeyResolver<T extends BillingArea>(name: Extract<keyof T, string>): string { return name; };

export const billingMenu: MenuMainNode = {
  icon: 'billingIconTemplate',
  title: 'Menu.Billing.Name',
  rootPath: '/billing',
  areaPermissionKey: permissionAreaKeyNameOf('billing'),
  children: [
    {
      title: 'Menu.Billing.Deposits.Name',
      abbreviation: 'Menu.Billing.Deposits.Abbreviation',
      link: '/billing/payments',
      entityPermissionKey: entityKeyResolver('deposits')
    },
    {
      title: 'Menu.Billing.PatientInvoices.Name',
      abbreviation: 'Menu.Billing.PatientInvoices.Abbreviation',
      link: '/billing/patient-invoices',
      entityPermissionKey: entityKeyResolver('patientInvoices')
    },
    {
      title: 'Menu.Billing.PaymentPlans.Name',
      abbreviation: 'Menu.Billing.PaymentPlans.Abbreviation',
      link: '/billing/payment-plans',
      entityPermissionKey: entityKeyResolver('paymentPlans')
    }
  ]
};
